import "./App.css";
import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import Loading from "./components/loading/Loading";
const Dashboard = React.lazy(() => import("./pages/dashboard/Dashboard"));
const CounselorHome = React.lazy(() => import("./pages/home/List"));
const GroupActions = React.lazy(() => import("./pages/groupActions/GroupActions"));
const Students = React.lazy(() => import("./pages/students/Students"));
const Meetings = React.lazy(() => import('./pages/meetings/Meetings'));
const ChallengePayment = React.lazy(() => import("./pages/payment/ChallengePayment"));
const Referral = React.lazy(() => import("./pages/referral/Referral"));
const CatchPole = React.lazy(() => import("./pages/catchpole/Catchpole"));
const Chronometer = React.lazy(() => import("./pages/chronometer/Chronometer"));
const QuizDefaultSettings = React.lazy(() => import("./pages/quizDefaultSettings/QuizDefaultSettings"));
const CreateExam = React.lazy(() => import("./pages/exams/Exams"));
const Discounts = React.lazy(() => import("./pages/discounts/Discounts"));
const ExamLanding = React.lazy(() => import("./pages/examLanding/ExamLanding"));
const PanelLayout = React.lazy(() => import("./layout/panel/PanelLayout"));
const Calendar = React.lazy(() => import("./pages/calendar/Calendar"));
const ExamAnalysis = React.lazy(() => import("./pages/examAnalysis/ExamAnalysis"));
const Login = React.lazy(() => import("./pages/landing/Login"));
const Settings = React.lazy(() => import("./pages/settings/Settings"));
const Report = React.lazy(() => import("./pages/report/Report"));
const Events = React.lazy(() => import("./pages/events/Events"));
const League = React.lazy(() => import("./pages/league/League"));
const Chat = React.lazy(() => import("./pages/chat/Chat"));
const Planner = React.lazy(() => import("./pages/planner/Planner"));
const NativeExams = React.lazy(() => import("./pages/nativeExams/NativeExams"));
const NativeExamEditor = React.lazy(() => import("./pages/nativeExamEditor/NativeExamEditor"));
const NativeExamDetail = React.lazy(() => import("./pages/nativeExamDetail/NativeExamDetail"));
const NativeExamSession = React.lazy(() => import("./pages/nativeExamSession/NativeExamSession"));
const NativeExamReport = React.lazy(() => import("./pages/nativeExamReport/NativeExamReport"));
const NativeExamCorrection = React.lazy(() => import("./pages/nativeExamCorrection/NativeExamCorrection"));
const WeeklySchedule = React.lazy(() => import("./pages/weeklySchedule/WeeklySchedule"));
const PlanPreview = React.lazy(() => import("./pages/planPreview/PlanPreview"));
const Register = React.lazy(() => import("./pages/landing/Register"));
const Wallet = React.lazy(() => import("./pages/wallet/Wallet"));
const Demo = React.lazy(() => import("./pages/demo/Demo"));
const Payment = React.lazy(() => import("./pages/payment/Payment"));
const File = React.lazy(() => import("./pages/file/File"));
const SquidGameChallenge = React.lazy(
  () => import("./pages/squidGameChallenge/SquidGameChallenge")
);
const MorningLeague = React.lazy(() => import("./pages/morningLeague/MorningLeague"));
const ExternalLogin = React.lazy(() => import("./pages/landing/ExternalLogin"));

function App() {
  return (
    <PanelLayout>
      <Suspense fallback={<Loading visible />}>
        <Routes>
          <Route Component={Dashboard} path="/home" />
          <Route Component={Dashboard} path="/" />
          <Route Component={Calendar} path="/calendar" />
          <Route Component={ExamAnalysis} path="/examAnalysis" />
          <Route Component={Login} path="/login" />
          <Route Component={Register} path="/register" />
          <Route Component={Settings} path="/settings" />
          <Route Component={Report} path="/report" />
          <Route Component={Planner} path="/planner" />
          <Route Component={NativeExams} path="/nativeExams" />
          <Route Component={NativeExamEditor} path="/nativeExamEditor" />
          <Route Component={NativeExamDetail} path="/nativeExamDetail" />
          <Route Component={NativeExamSession} path="/nativeExamSession" />
          <Route Component={NativeExamReport} path="/nativeExamReport" />
          <Route Component={NativeExamCorrection} path="/nativeExamCorrection" />
          <Route Component={Events} path="/events" />
          <Route Component={League} path="/league" />
          <Route Component={Chat} path="/chat" />
          <Route Component={CounselorHome} path="/list" />
          <Route Component={WeeklySchedule} path="/weeklySchedule" />
          <Route Component={PlanPreview} path="/planPreview" />
          <Route Component={Wallet} path="/wallet" />
          <Route Component={Demo} path="/demo" />
          <Route Component={Payment} path="/payment" />
          <Route Component={File} path="/file" />
          <Route Component={ExamLanding} path="/ExamLanding" />
          <Route Component={Discounts} path="/discounts" />
          <Route Component={CreateExam} path="/exams" />
          <Route Component={QuizDefaultSettings} path="/quizDefaultSettings" />
          <Route Component={CatchPole} path="/catchpole" />
          <Route Component={Chronometer} path="/chronometer" />
          <Route Component={SquidGameChallenge} path="/squidGameChallenge" />
          <Route Component={MorningLeague} path="/morningLeague" />
          <Route Component={Referral} path="/referral" />
          <Route Component={ChallengePayment} path="/challengePayment" />
          <Route Component={Meetings} path='/meetings' />
          <Route Component={ExternalLogin} path="/external-login" />
          <Route Component={Students} path="/students/:id" />
          <Route Component={Students} path="/students" />
          <Route Component={GroupActions} path="/actions/:type" />
        </Routes>
      </Suspense>
    </PanelLayout>
  );
}

export default App;
